import gql from 'graphql-tag';

export const deleteAdSetMutation = gql`
  mutation deleteAdSet($id: Float!) {
    deleteAdSet(id: $id)
  }
`;
